import { Tooltip } from '~/components/Tooltip/Tooltip';
import { Badge } from '~/components/Badge/Badge';
import { RecordStatusEnum } from '~/apis/ssf';
import { match } from 'ts-pattern';

interface Props {
  status: RecordStatusEnum | undefined;
  label?: string;
}

export function RecordBadge({ status, label }: Props) {
  return match(status)
    .with('include', () => (
      <Tooltip title={'Inkludera resultatet'}>
        <Badge variant="success" label={label ?? ''} />
      </Tooltip>
    ))
    .with('exclude', () => (
      <Tooltip title={'Exkludera resultatet'}>
        <Badge variant="danger" label={label ?? ''} />
      </Tooltip>
    ))
    .otherwise(() => null);
}
